import { stdObject } from "../../../data/types/stdObject";
import { startGuarantee } from "./document/startGuarantee";
import { openDocTransfer } from "./openDocTransfer";
import { openFormDialog } from "./openFormDialog";
import { openPrinterDialog } from "./stationery/openPrinterDialog";

export const startAction = (
  { action = false, code, msg, start = false, docSndValues = false }: stdObject,
  params: stdObject,
) => {
  const {
    t,
    user,
    items,
    userAccess,
    docValues,
    documentAction,
    setDocValues,
    setStationeryModal,
    openModal,
    setMsg,
    setMsg2,
    setModalData,
    setModalData2,
    closeMsg,
    openInnerSelection,
    setWindowValues,
    guarantees,
    logoutAction,
  } = params;

  if (!start) {
    documentAction.current = { action, code, msg };
  }

  if (!action) {
    action = documentAction.current.action;
  }

  if (!docSndValues) {
    docSndValues = docValues;
  }

  if (!start && (docSndValues.updated || code === 0)) {
    setMsg("askToClose");
  } else if (start || !docSndValues.updated) {
    switch (action) {
      case "print":
        openPrinterDialog(
          {
            sectionType: {
              id: docSndValues.sectionId,
              code: docSndValues.type,
            },
            data: {
              [`SER${docSndValues.type}`]: docSndValues.serie,
              [`COD${docSndValues.type}`]: code,
            },
            type: docSndValues.typeText,
          },
          {
            setDocValues,
            setStationeryModal,
            setMsg,
            closeMsg,
            logoutAction,
          },
        );
        break;
      case "form":
        openFormDialog(
          { paper: false },
          {
            t,
            user,
            docValues,
            setMsg,
            setModalData,
            setDocValues,
            setStationeryModal,
            closeMsg,
            logoutAction,
          },
        );
        break;
      case "transfer":
        openDocTransfer({
          level: 1,
          docValues: docSndValues,
          openModal,
          closeMsg,
          items,
          country: user.CODPAI,
          userAccess,
          logoutAction,
        });
        break;
      case "guarantee":
        startGuarantee({
          t,
          documentAction,
          setWindowValues,
          guarantees,
          openInnerSelection,
          setMsg,
          setMsg2,
          closeMsg,
          setModalData,
          setModalData2,
        });
        break;
    }
  }
};
